export const isSignImage = (url: string): boolean => {
  return url.includes(import.meta.env.VITE_BUCKET_CHAT)
}
